
	var matchedProducts;

	$(document).ready(function() {
       $('input').click(function() {
         
            $("#ebody-height").find("input[type='radio']").parent('label').removeClass("checked");
            $("#ebody-height").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-weight").find("input[type='radio']").parent('label').removeClass("checked");
            $("#ebody-weight").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-riding-ability").find("input[type='radio']").parent('.riding-col').removeClass("checked");
            $("#ebody-riding-ability").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-years-riding").find("input[type='radio']").parent('label').removeClass("checked");
            $("#ebody-years-riding").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-water-temp").find("input[type='radio']").parent('.riding-col').removeClass("checked");
            $("#ebody-water-temp").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-wave-kind").find("input[type='radio']").parent('label').removeClass("checked");
            $("#ebody-wave-kind").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-riding-style").find("input[type='radio']").parent('.riding-col').removeClass("checked");
            $("#ebody-riding-style").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-riding-swimfins").find("input[type='radio']").parent('.riding-col').removeClass("checked");
            $("#ebody-riding-swimfins").find("input[type='radio']").parent('label').removeClass("ebody-unselected");
            $("#ebody-price-range").find("input[type='radio']").parent('label').removeClass("checked");
            $("#ebody-price-range").find("input[type='radio']").parent('label').removeClass("ebody-unselected");

            if ($("#ebody-height").find("input[type='radio']:checked")) {
                $("#ebody-height").find("input[type='radio']:checked").parent('label').addClass("checked");
            } else if($("#ebody-height").find("input[type='radio']:checked").length == 0){
              	$('.spanError').show();
           		$('html, body').animate({
                	scrollTop: $(".spanError").offset().top
    			}, 'slow');
            }

            if ($("#ebody-weight").find("input[type='radio']:checked")) {
                $("#ebody-weight").find("input[type='radio']:checked").parent('label').addClass("checked");
            }

            if ($("#ebody-riding-ability").find("input[type='radio']:checked")) {
                $("#ebody-riding-ability").find("input[type='radio']:checked").parent('.riding-col').addClass("checked");
            }

            if ($("#ebody-years-riding").find("input[type='radio']:checked")) {
                $("#ebody-years-riding").find("input[type='radio']:checked").parent('label').addClass("checked");
            }

            if ($("#ebody-water-temp").find("input[type='radio']:checked")) {
                $("#ebody-water-temp").find("input[type='radio']:checked").parent('.riding-col').addClass("checked");
            }

            if ($("#ebody-wave-kind").find("input[type='radio']:checked")) {
                $("#ebody-wave-kind").find("input[type='radio']:checked").parent('label').addClass("checked");
            }

            if ($("#ebody-riding-style").find("input[type='radio']:checked")) {
                $("#ebody-riding-style").find("input[type='radio']:checked").parent('.riding-col').addClass("checked");
            }

            if ($("#ebody-riding-swimfins").find("input[type='radio']:checked")) {
                $("#ebody-riding-swimfins").find("input[type='radio']:checked").parent('.riding-col').addClass("checked");
            }

            if ($("#ebody-price-range").find("input[type='radio']:checked")) {
                $("#ebody-price-range").find("input[type='radio']:checked").parent('label').addClass("checked");
            }
        });
    });
  
  
    $(document).on('click' , '.information', function(){
      
         if ( 1 == $('.information').attr('data-id') ) {
             $('#tip1').show();
         }
         
      	 if (3 == $('.information').attr('data-id')) {
             $('#tip2').show();
         }
      
         if (5 == $('.information').attr('data-id')) {
             $('#tip3').show();
         }
      
      	 if ( 2 == $('.information').attr('data-id') ) {
             $('#tip4').show();
         }
      
      	 if ( 6 == $('.information').attr('data-id') ) {
             $('#tip5').show();
         }
      
       	 if ( 7 == $('.information').attr('data-id') ) {
             $('#tip6').show();
         }
      
      	 if ( 4 == $('.information').attr('data-id') ) {
             $('#tip7').show();
         }
      
         if ( 8 == $('.information').attr('data-id') ) {
             $('#tip8').show();
         }
    });



  
    $(document).on('click' , '.close', function(){
        $('.ebodyboarding-tips').hide();
    });

  	
	$(document).on('click' , '#netBtn', function(){
    	var currentPage = parseInt($(this).attr('data-id'));
    	var nextPage = currentPage + parseInt(1);
    	$('.spanError').hide();
        if($("#step_"+currentPage).find("input[type='radio']:checked").length == 0 && currentPage != 1) {
          	$("#step_"+currentPage).find("input[type='radio']").parent('label').addClass("ebody-unselected");
			$('.spanError').show();
          	$('html, body').animate({
                scrollTop: $(".spanError").offset().top - 82
    		}, 'slow');
          	return;
        }
    	$('.information, .ebodyboarding-tips').hide();
        if($("#step_"+nextPage).hasClass('infotooltip')){
			$('.information').show();
          	$('.information').attr('data-id', currentPage);
        }
        $('.tab').addClass('ebody-inactive');
    	$("#step_"+nextPage).addClass('ebody-active').removeClass('ebody-inactive');
        if(nextPage > 1){
          $('#preBtn').show();
          $('#preBtn').attr('data-id', currentPage);
        }
        if($('.ebody-form .tab').length == nextPage){
			$(this).hide();
          	return;
        }
    	$(this).attr('data-id',nextPage);
    });
  
  
    $(document).on('click' , '#preBtn', function(){
      	$('.tab').addClass('ebody-inactive');
      	$('#netBtn').show();
      	var prevPage = parseInt($(this).attr('data-id'));
      	$("#step_"+prevPage).addClass('ebody-active').removeClass('ebody-inactive');
      	$('.information, .ebodyboarding-tips').hide();
        if($("#step_"+prevPage).hasClass('infotooltip')){
			$('.information').show();
          	$('.information').attr('data-id', prevPage - parseInt(1));
        }
        if(prevPage < 2){
          $('#preBtn').hide();
          $('#preBtn').removeAttr('data-id');
        }
      	$('#netBtn').attr('data-id', prevPage);
    	$(this).attr('data-id',prevPage - parseInt(1));
    });


  	$(document).on('click' , '#email_submit', function( event ){
      	event.preventDefault();
      	$('.ebody-email-error .empty-email-error').text('');
      	var email = $('#email').val();
      	
      	if ( email != '' && IsEmail( email ) ) {
         
          	let form_data = $("#Quizform").serializeArray();
          	let _height, _weight,  heightWeightCombination, heightWeightCombinationResult, waveType_temprature, _user_email, _price;
          	let _temprature, _waveType, tailValue, coreValue, _weight_check, _riding_style;
          
          	let _height_weight_data = {
              		'4’-4’10': {
                    	"Under_50_lbs"  : '33"',
                    	"50_lbs_70lbs"  : '33" or 34"',
                    	"70lbs_85lbs"   : '34" or 36"',
                    	"85lbs_100lbs"  : '36"',
                    	"100lbs_115lbs" : '36"',
                    	"115lbs_130lbs" : '36"',
              		},
              		"4'11-5'":{
                    	"Under_50_lbs"  : '33" or 34"',
                    	"50_lbs_70lbs"  : '33" or 34"',
                    	"70lbs_85lbs"   : '34" or 36"',
                    	"85lbs_100lbs" 	: '36"',
                    	"100lbs_115lbs" : '36"',
                    	"115lbs_130lbs" : '38"',
                    	"130lbs_145lbs" : '38"',
                    	"145lbs_160lbs" : '39"',
              		},
            		'5’-5’2”':{
                    	"Under_50_lbs"  : '34"',
                    	"50_lbs_70lbs"  : '36"',
                    	"70lbs_85lbs"   : '36" or 38"',
                    	"85lbs_100lbs"  : '38"',
                    	"100lbs_115lbs" : '38"',
                    	"115lbs_130lbs" : '38"',
                    	"130lbs_145lbs" : '39"',
                    	"145lbs_160lbs" : '39"',
                    	"160lbs_175lbs" : '40"',
                    	"175lbs_190lbs" : '40"',
              		},
          			'5’3”-5’5”':{
                    	"70lbs_85lbs" 	: '38"',
                    	"85lbs_100lbs" 	: '38" or 39"',
                    	"100lbs_115lbs" : '38" or 39" or 40"',
                    	"115lbs_130lbs" : '39" or 40"',
                    	"130lbs_145lbs" : '39" or 40"',
                    	"145lbs_160lbs" : '39" or 40"',
                    	"160lbs_175lbs" : '39" or 41"',
                    	"175lbs_190lbs" : '39" or 41"',
                    	"190lbs_210lbs" : '42" Wide',
                    	"210lbs_225lbs" : '42" Wide',
                    	"225lbs_250lbs" : '42" Wide',
                     	"250lbs+" 		: 'Tanker or Beast 42"',
                        "190lbs-210lbs"	: '42" Wide/Thick',
                        "210lbs-225lbs"	: '42" Wide/Thick',
                        "225lbs-250lbs"	: '42" Wide/Thick',
                        "250lbs+"		: 'Tanker or Beast 42"'
              		},
      				'5’6”-5’8”':{
                    	"85lbs_100lbs" : '40"',
                    	"100lbs_115lbs" : '40" or 41"',
                    	"115lbs_130lbs" : '40" or 41"', 
                    	"130lbs_145lbs" : '41"',
                    	"145lbs_160lbs" : '41" or 41.5"',
                    	"160lbs_175lbs" : '41" or 41.5"',
                    	"175lbs_190lbs" : '42" or 41.5"',
                    	"190lbs_210lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                    	"210lbs_225lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                    	"225lbs_250lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                     	"250lbs+" 		: 'Tanker or Beast 42"',
                      	"190lbs-210lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                      	"210lbs-225lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                      	"225lbs-250lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                      	"250lbs+"       : 'Tanker or Beast 42"'
              		},
      				'5’9”-6’0”':{
                    	"100lbs_115lbs" : '41" or 41.5"',
                    	"115lbs_130lbs" : '41.5" or 42"',
                    	"130lbs_145lbs" : '41" or 42"',
                    	"145lbs_160lbs" : '41.5" or 42"',
                    	"160lbs_175lbs" : '41.5" or 42"',
                    	"175lbs_190lbs" : '41.5" or 42"',
                    	"190lbs_210lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                    	"210lbs_225lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                    	"225lbs_250lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                     	"250lbs+" 		: 'Tanker or Beast 42"',
                      	"190lbs-210lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                      	"210lbs-225lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                      	"225lbs-250lbs" : '42" Wide or 42.5" Wide or 43" Wide or 43.5" Wide',
                      	"250lbs+"       : 'Tanker or Beast 42"'
              		},
            		'6’1”-6’3”':{
                    	"130lbs_145lbs" : '42.5"',
                    	"145lbs_160lbs" : '42.5" or 43"',
                    	"160lbs_175lbs" : '42.5" or 43"',
                    	"175lbs_190lbs" : '43" or 43.5"',
                    	"190lbs_210lbs" : '43" or 43.25" Wide or 43.5" Wide or 44"',
                    	"210lbs_225lbs" : '43.25" Wide or 43.5" Wide or 44"',
                    	"225lbs_250lbs" : '43.25" Wide or 43.5" Wide or 44" Wide or 44"',
                     	"250lbs+" 		: 'Thunder 45" or Tanker or Beast 45"',
                      	"190lbs-210lbs" : '43” or 43.25" Wide or 43.5" Wide or 44”',
                      	"210lbs-225lbs" : '43.25" Wide or 43.5" Wide or 44”',
                      	"225lbs-250lbs" : '43.25" Wide or 43.5" Wide or 44" Wide or 44”',
                      	"250lbs+"       : 'Thunder 45" or Tanker or Beast 45"'
              		},
             		'6’4”-6’6”':{
                    	"130lbs_145lbs" : '43.5" or 44" or 44.5" or 46" ',
                    	"145lbs_160lbs" : '43.5" or 44" or 44.5" or 46"',
                    	"160lbs_175lbs" : '43" or 43.5" or 44" or 44.5" or 46"',
                    	"175lbs_190lbs" : '43" or 44" or 44.5 or 45" or 46"',
                    	"190lbs_210lbs" : '43.25" Wide or 43.5" Wide or 44" or 44.5" or 45" or 46"',
                    	"210lbs_225lbs" : '43.25" Wide or 43.5" Wide or 44" Wide or 44.5" or 46"',
                    	"225lbs_250lbs" : '44" or 44.5" or 45" or 46" or Tanker or Beast 45"',
                    	"250lbs+" 		: 'Thunder 45" or Tanker or Beast 48" or Tanker or Beast 45"',
              		},
            		'6’7"+':{
                    	"175lbs_190lbs" : '45" or 46" or Tanker or Beast 48"',
                    	"190lbs_210lbs" : '45" or 46" or Tanker or Beast 48"',
                    	"210lbs_225lbs" : '45" or 46" or Tanker or Beast 48"',
                    	"225lbs_250lbs" : '45" or 46" or Tanker or Beast 48"',
                     	"250lbs+" 		: '45" or 46" or Tanker or Beast 48"',
              		}
    		}
          
            let _sizeArray = {
              		'32"' 	  		: 	"32",
              		'33"' 	  		:	"33",
              		'34"'			:	"34",
              		'36"'			:	"36",
              		'38"'			:	"38",
              		'39"' 	  		:	"39",
              		'40"'			:	"40",
              		'41"'			:	"41",
              		'41.5"'	  		:	"41.5",
              		'42"'			:	"42",
              		'42" Wide' 		:	"42-wide",
              		'42.5"'	  		:	"42.5",
              		'42.5" Wide'	:	"42-5-wide",
              		'43"'			:	"43",
              		'43" Wide'		:	"43-wide",
              		'43.25" Wide'	:	"43-25-wide",
              		'43.5" Wide'	:	"43-5-wide",
              		'44"'			:	"44",
              		'44" Wide'		:	"43-5-wide",
              		'45"'			:	"45",
              		'46"'			:	"46",
              		'48"'			:	"48",
            	};
            
            
          	let _waveTypeArray = {
                    "Soft breaking waves" : {
                        0 : "Bat",
                        1 : "Crescent"
                    },
                    "hollow waves" : {
                        0 : "Crescent"
                    },
                    "long peeling waves" : {
                        0 : "Crescent" ,
                        1 : "Bat"
                    },
                    "big waves" : {
                        0 : "Crescent"
                    },
              		"various waves" : {
                		 0 : "Crescent" ,
                         1 : "Bat"
              		}
            	}
            
            
            let _tempArray = {
              	"Soft breaking waves" : {
                		"cool" : {
                  	 		"EPS" 	: "Polystyrene (EPS)",
                        	"PE" 	: "Polyethylene (PE)"
                		},
                 		"warm" : {
                  	 		"EPS" 	: "Polystyrene (EPS)",
                        	"PE" 	: "Polyethylene (PE)",
                  			"PP" 	: "Polypropylene (PP)"
                		},
                		"tropical" : {
                  	 		"PP" 	: "Polypropylene (PP)",
                        	"PE" 	: "Polyethylene (PE)"
                		},
                		"Various" : {
                      		"EPS" 	: "Polystyrene (EPS)", 
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		}
            	},
              	"hollow waves" : {
                		"cool" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"warm" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"tropical" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"Various" : {
                      		"EPS" 	: "Polystyrene (EPS)", 
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		}
              	},
              	"long peeling waves" : {
                		"cool" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"warm" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"tropical" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                 		"Various" : {
                      		"EPS" 	: "Polystyrene (EPS)", 
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		}
              	},
      		  	"big waves" : {
                		"cool" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"warm" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"tropical" : {
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"Various" : {
                      		"EPS" 	: "Polystyrene (EPS)",
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		}
              	},
                "various waves" : {
                		"cool" : {
                          	"EPS" 	: "Polystyrene (EPS)",
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"warm" : {
                        	"EPS" 	: "Polystyrene (EPS)",
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"tropical" : {
                        	"EPS" 	: "Polystyrene (EPS)",
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		},
                		"Various" : {
                      		"EPS" 	: "Polystyrene (EPS)",
                        	"PE" 	: "Polyethylene (PE)",
                      		"PP" 	: "Polypropylene (PP)"
                		}
              	},
            }
            	
            var customer_data = {Form:'Quiz'};
            
        	form_data.forEach( it => {
              
            	if(it.name == "ebody-height"){
                		_height = $.trim( it.value );
                      	customer_data['Height']=it.value;
                }
                if(it.name == "ebody-weight"){
                      	_weight = $.trim( it.value );
                      	customer_data['Weight']=it.value;
                }
                if(it.name == "ebody-riding-ability"){
                      	customer_data['Riding ability']=it.value;
                }
                if(it.name == "ebody-years-riding"){
                      	customer_data['Years']=it.value;
                }
                if(it.name == "ebody-water-temp"){
                      	_temprature = $.trim( it.value );
                      	customer_data['Water temp']=it.value;
                }
                if(it.name == "ebody-wave-kind"){
                      	_waveType = $.trim( it.value );
                      	customer_data['Wave']=it.value;
                }
                if(it.name == "ebody-riding-style"){
                  		_riding_style = $.trim( it.value );
                      	customer_data['Style']=it.value;
                }
                if(it.name == "ebody-riding-swimfins"){
                      	customer_data['Swimfins']=it.value;
                }
                if(it.name == "ebody-price-range"){
                  	  	_price = $.trim( it.value );
                      	customer_data['Price']=it.value;
                }
                if(it.name == "email"){
                      	_user_email = it.value;
                      	_learnq.push([ 'identify', { '$email' : it.value }] );
                      	customer_data['$email'] = it.value;
                }
             });
          
           	var _excluded_tags 	= [];
          	var _include_tags	= [];
			var product_height 	= [];
          	var coreValueArray 	= [];
          	var tailValueArray 	= [];
          	var user_sel 		= [];
          	var check_height = '';
          	var riding_style_tag = '';
          
            heightWeightCombination = _height_weight_data[_height];
            heightWeightCombinationResult = heightWeightCombination[_weight];
          
          	if ( typeof(heightWeightCombinationResult) != 'undefined' ) {
                let hightweight = heightWeightCombinationResult.split("or");
                
              	jQuery.each( hightweight, function( index, value ) {
                  	let val = $.trim(value);
                  	if( _sizeArray[val] != "" ) {
                        // user_sel.push( _sizeArray[val] );
                      	product_height.push( _sizeArray[val] );
                    }
                });
              
              	tailValue = _waveTypeArray[_waveType];
              	coreValue = _tempArray[_waveType][_temprature];
              	
                $('.footer-disclaimer').show();
              
                if( tailValue == undefined || coreValue == undefined || heightWeightCombinationResult == undefined ) {

                     setFinalResultError('no' , 'no', 'no' );
                    _learnq.push([ 'identify', { '$email':  _user_email, 'Result' : 'No Product Found' }] );

                } else if( tailValue == '' || coreValue == '' || heightWeightCombinationResult == '' ) {

                     setFinalResultError('no' , 'no', 'no' );
                    _learnq.push([ 'identify', { '$email':  _user_email, 'Result' : 'No Product Found' }] );

                } else if( tailValue != '' && coreValue != '' && heightWeightCombinationResult != '' ) {
					
                  
                  	_weight_check = jQuery( 'input[name=ebody-weight]:checked' ).data('weight');

                    let wave_type 	= _waveTypeArray[_waveType];
                    let temprature 	= _tempArray[_waveType][_temprature];

                    for ( var key in wave_type ) {
                        user_sel.push(wave_type[key]);
                    }

                    for ( var key1 in temprature ) {
                        user_sel.push(temprature[key1]);
                    }
                  
                  	for ( var key in coreValue ) {
                      	coreValueArray.push( key );
					}
                  
                  	for ( var key in tailValue ) {
                      	tailValueArray.push( tailValue[key] );
					}
                  	
                  	// conditions ....
                  	if( _riding_style == 'Stand-Up' ) {
                      	// tagged “stand up”, no bat, show only 45”+
                      
                      	 riding_style_tag = 'standup';
                      
                      	_include_tags.push('standup');
                      
                      	 user_sel.push('standup');
                      	_excluded_tags.push( 'bat' );
                      	_excluded_tags.push( 'Bat' );
                      
                      	 user_sel.remove('Bat');
                      	 tailValueArray.remove('Bat');
                      
                      	 check_height = '45';
                      	 heightWeightCombinationResult = '45"+';
                    }
                  	
                  	if( _riding_style == 'Prone-Riding' ) {
                      
                      // exclude products with tags "dropknee", "bodysurfing", and "stand up", not bat
                   	 	_excluded_tags.push( 'dropknee' );
                      	_excluded_tags.push( 'bodysurfing' );
                     	_excluded_tags.push( 'Bodysurfing' );
                      	_excluded_tags.push( 'standup' );
                      
                      	_excluded_tags.push( 'bat' );
						_excluded_tags.push( 'Bat' );
                      
                      	 user_sel.remove('Bat');
                      	 tailValueArray.remove('Bat');
                      
                      	 riding_style_tag = 'proneriding';
                  	}
                  	
                  	if( _riding_style == 'Drop-Knee' ) {
                      	
                       // tagged “dropknee”, no bat, standup, or bodysurfing boards
                      	 user_sel.push('dropknee');
                      	_include_tags.push('dropknee');
                      
                      	_excluded_tags.push( 'standup' );
                      	_excluded_tags.push( 'bodysurfing' );
                      	_excluded_tags.push( 'Bodysurfing' );
                      	_excluded_tags.push( 'bat' );
                      	_excluded_tags.push( 'Bat' );
                      
                      	 user_sel.remove('Bat');
                      	 tailValueArray.remove('Bat');
                      
                      	riding_style_tag = 'dropknee';
                  	}
                  	
                  	if( _riding_style == 'Combo' ) {
                   	 	// only crescent
                      	 _excluded_tags.push( 'bat' );
                      	 _excluded_tags.push( 'Bat' );
                      
                      	  user_sel.remove('Bat');
                      	  tailValueArray.remove('Bat');
                      
                      	  riding_style_tag = 'combo';
                  	}
                  	
                  	if( _riding_style == 'Bodysurfing' ) {
                   	 	// tagged "bodysurfing"
                        _include_tags.push('bodysurfing');
                      	user_sel.push('bodysurfing');
                      	riding_style_tag = 'bodysurfing';
                  	}
                  
                  	
                  	// Wave Type - Determines board tail (hollow= show no bat)
                  	if( _waveType == 'hollow waves' ) {
                      	_excluded_tags.push( 'bat' );
                      	_excluded_tags.push( 'Bat' );
                      
                      	 user_sel.remove('Bat');
                      	 tailValueArray.remove('Bat');
                  	}
                  	
                  	// Water Temperature - Determines board core (Tropical= show no EPS)
                  	if( _temprature == 'tropical' ) {
                      	_excluded_tags.push('Polystyrene (EPS)');
                      	 user_sel.remove('Polystyrene (EPS)');
                      	 coreValueArray.remove('EPS');
                  	}
                  
              		// Weight if over 190lbs include Tag: “HV”
                  	if( _weight_check == 'above190' ) {
                      	_include_tags.push('HV');
                      	 user_sel.push('HV');
                    } else {
                      	_excluded_tags.push('HV');
                    }
                  
                  	
                  	// Adpative style product 
                  	if( _riding_style == 'Adaptive' ) {
                      	
                      	riding_style_tag = 'adaptive';
                      	
                      	user_sel = ['adaptive'];
                      	_include_tags = [];
                       _excluded_tags = []
                    }
                  
                  	
                  	var tailStringValue = (typeof tailValueArray[1] != 'undefined') ? tailValueArray[0] + " Or " + tailValueArray[1] : tailValueArray[0];
                  	
                  	if( coreValueArray.length == 1 ) {
                      	var coreStringValue = coreValueArray[0];
                  	} else if ( coreValueArray.length == 2 ) {
                      	var coreStringValue = coreValueArray[0] + ' and ' + coreValueArray[1] ;
                  	} else if( coreValueArray.length == 3 ) {
                      	var coreStringValue = coreValueArray[0] + ', ' + coreValueArray[1] + ' and ' + coreValueArray[2]  ;
                  	}
                  
                  	customer_data['Length']=heightWeightCombinationResult;
                  	customer_data['Core']=coreStringValue;
                  	customer_data['Tail']=tailStringValue;
                    _learnq.push( ['identify', customer_data] );
                    _learnq.push( [ 'identify', {'$email':  _user_email, 'Result' : 'Product Found' } ] );
                  
                  	var _include_tags_hv_boadyboarding	= [];
                  	var height_check = false;
                  
                  	if( _weight_check == 'above190' && riding_style_tag == 'bodysurfing' ) {
                      
                      	height_check = true;
                      	_include_tags_hv_boadyboarding.push('HV');
                        _include_tags_hv_boadyboarding.push('bodysurfing');
                        _include_tags_hv_boadyboarding.push('Bodysurfing');

                      	matchedProducts = findMatchedProductsHV( _include_tags_hv_boadyboarding );
                  
                  	} else if( _weight_check == 'above190' ) {
                      
                      	height_check = true;
                      	_include_tags_hv_boadyboarding.push('HV');
                      	
                      	matchedProducts = findMatchedProductsHV( _include_tags_hv_boadyboarding );
                  	
                    } else if ( riding_style_tag == 'bodysurfing' ) {
                      
                      	height_check = true;
                      	_include_tags_hv_boadyboarding.push('bodysurfing');
                        _include_tags_hv_boadyboarding.push('Bodysurfing');
                      
                      	matchedProducts = findMatchedProductsHV( _include_tags_hv_boadyboarding );
                 	
                    } else {
                      
                      	matchedProducts = findMatchedProducts( user_sel, _excluded_tags , _include_tags );
                      
                    }
                  
                  	setFinalResultSuccessHtml();
                  
                    var j = 0;
                  	$.each( matchedProducts, function( index, value ) {
                      	var variant_id = ''; var start_price = '';
                       	var last_price = ''; var price_range = '';
                      	
                      	jQuery.each( allBodyBoardsVariants[value], function( i, v ) {
                          	if( v.inventory_qty > 0 ) {
                                 var compare_price = parseInt( v.price ) ;
                                  if( check_height != '' ) {
                                    	if( parseFloat(v.height) > parseFloat(check_height) || height_check ) {
                                          if( _price == 50 ) {
                                                let price = parseInt( _price * 100 );
                                                if( compare_price  <=  price ) {
                                                    variant_id = i;
                                                }
                                            } else if ( _price == 250 ) {
                                                let price = parseInt( _price * 100 );
                                                if( compare_price  >=  price ) {
                                                    variant_id = i;
                                                }
                                            } else if( _price == 'any' ) {
                                                variant_id = i;
                                            } else {
                                                price_range = _price.split('-');
                                                start_price = parseInt( price_range[0] * 100 );
                                                last_price = parseInt( price_range[1] * 100 );
                                                if ( compare_price >= start_price && compare_price <= last_price ) {
                                                    variant_id = i;
                                                    return false;
                                                }
                                            }
                                      	}
                                  } else {
                                      if( jQuery.inArray( v.height, product_height ) !== -1 || height_check ) {
                                         if( _price == 50 ) {
                                              let price = parseInt( _price * 100 );
                                              if( compare_price  <=  price ) {
                                                  variant_id = i;
                                              }
                                          } else if ( _price == 250 ) {
                                              let price = parseInt( _price * 100 );
                                              if( compare_price  >=  price ) {
                                                  variant_id = i;
                                              }
                                          } else if( _price == 'any' ) {
                                              variant_id = i;
                                          } else {
                                              price_range = _price.split('-');
                                              start_price = parseInt( price_range[0] * 100 );
                                              last_price = parseInt( price_range[1] * 100 );
                                              if ( compare_price >= start_price && compare_price <= last_price ) {
                                                  variant_id = i;
                                                  return false;
                                              }
                                          }
                                      }
                                  }
                         	 }
                        });
                      
                      	if( variant_id != '' ) {
                          	var query_params = ( variant_id == '' ) ? '' : '?variant='+ variant_id;
                          	var display = ( j > 2 ) ? 'none' : 'block';
                          	let product_html = '';
                          		product_html += '<div data-product_id="'+ value +'" data-varient_id="'+ variant_id +'" style="display:'+ display +'" class="products col-md-4 matched-'+ index +'"">';
                                product_html += '<div class="board-col matched-product-'+ index +'">';
                                product_html += '<a target="_blank" href = "https://ebodyboarding.com/products/'+ allBodyBoardsProducts[value].handle + query_params + '">'
                                product_html += '<img src="'+ allBodyBoardsProducts[value].featured_image +'">';
                                product_html += '<p>'+ allBodyBoardsProducts[value].title +'</p><p>'+Shopify.formatMoney(allBodyBoardsVariants[value][variant_id].price, window.money_format)+'</p></a>';
                                product_html += '</div></div>';
                          
                          	$("#ebody-best-board-for-you").append( product_html );
                            j++
                        }
                    });
                  
                    if( j == 0 ) {
                        setFinalResultError( heightWeightCombinationResult, coreStringValue, tailStringValue );
                    } else if( j > 3 ) {
                       	$('.board-btn .show-more-products').show();
                       	setFinalResultSuccess( heightWeightCombinationResult, coreStringValue, tailStringValue );
                    } else {
                      	$('.back-again').show();
                        setFinalResultSuccess( heightWeightCombinationResult, coreStringValue, tailStringValue );
                    }
                  
                } else {
                    setFinalResultError( heightWeightCombinationResult, coreStringValue, tailStringValue );
                    _learnq.push([ 'identify', {'$email':  _user_email, 'Result' : 'No Product Found' }] );
                }
            }  else {
              	 setFinalResultError( heightWeightCombinationResult, coreStringValue, tailStringValue );
               	_learnq.push([ 'identify', {'$email':  _user_email, 'Result' : 'No Product Found' }] );
            }
          	$('.ebody-btn').hide();
          	return false;
        } else {
          	$('.ebody-email-error .empty-email-error').text('Please enter an valid email to continue');
		    return false;
        }
    });

   
	// on click show more simmilar products ...
    $(document).on('click', '.show-more-products', function(){
      	$('.products').show();
      	$(this).hide();
      	$('.board-btn .back-again').show();
    });

	// on click Back again on final step ...
    $(document).on('click', '.back-again', function(){
      	$('#final_step').addClass('ebody-inactive').removeClass('ebody-active');
      	$('.tab').addClass('ebody-inactive');
      	$("#step_11").addClass('ebody-active').removeClass('ebody-inactive');
      	$('.information, .ebodyboarding-tips').hide();
      	$('#preBtn').show();
      	$('#netBtn').attr('data-id', "10");
      	$('#preBtn').attr('data-id', "10");
    });

	// on click price range on final step ...
    $(document).on('click', '.jumpto-price-range', function(){
      	$('#final_step').addClass('ebody-inactive').removeClass('ebody-active');
      	$('.tab').addClass('ebody-inactive');
      	$("#step_10").addClass('ebody-active').removeClass('ebody-inactive');
      	$('.information, .ebodyboarding-tips').hide();
      	$('#preBtn, #netBtn').show();
      	$('#netBtn').attr('data-id', "10");
      	$('#preBtn').attr('data-id', "9");
    });

	// on click riding style on final step ..	
    $(document).on('click', '.jumpto-riding-style', function(){
      	$('#final_step').addClass('ebody-inactive').removeClass('ebody-active');
      	$('.tab').addClass('ebody-inactive');
      	$("#step_8").addClass('ebody-active').removeClass('ebody-inactive');
      	$('.information, .ebodyboarding-tips').hide();
      	$('#preBtn, #netBtn').show();
      	$('#netBtn').attr('data-id', "8");
      	$('#preBtn').attr('data-id', "7");
    });

	// on click wave type on final step ..
    $(document).on('click', '.jumpto-wave-type', function(){
      	$('#final_step').addClass('ebody-inactive').removeClass('ebody-active');
      	$('.tab').addClass('ebody-inactive');
      	$("#step_7").addClass('ebody-active').removeClass('ebody-inactive');
      	$('.information, .ebodyboarding-tips').hide();
      	$('#preBtn, #netBtn').show();
      	$('#netBtn').attr('data-id', "7");
      	$('#preBtn').attr('data-id', "6");
    });


	// find match product ...	
	function findMatchedProductsHV( include_tags ) {
      	var MatchedProducts = [];
      	jQuery.each( allBodyBoardsProducts, function( index, value ) {
        	var include_tag_check = include_tags.some(item => (value.tags).includes(item)) 
            	if( include_tag_check ) {
                	MatchedProducts.push( index  );
                    return true;
              	}
        });
    	return MatchedProducts;
	}

	
	// check include and exclude items form the products and find matched products     
	function findMatchedProducts( user_sel, excluded_tags, include_tags ) {
      	var MatchedProducts = [];
      console.log(excluded_tags);
      console.log(include_tags);
      console.log(user_sel);
      	jQuery.each( allBodyBoardsProducts, function( index, value ) {
          	if( excluded_tags.length > 0 ) {
            	var exclude_tag_check = excluded_tags.some(item => (value.tags).includes(item)) 
          	} else {
            	var exclude_tag_check = false;        
          	}
          	if( ! exclude_tag_check  ) {
              	if( include_tags.length > 0 ) {
            		var include_tag_check = include_tags.every(item => (value.tags).includes(item)) 
          		} else {
            		var include_tag_check = true;        
          		}
              	if( include_tag_check ) {
              		var check_if_tag_exist = user_sel.some(item => (value.tags).includes(item)) 
              		if( check_if_tag_exist  ) {
                    	MatchedProducts.push( index  );
                    	return true;
                	}
              	}
          	}
        });
      console.log(MatchedProducts);
    	return MatchedProducts;
    }
	

    // set final result 
    function setFinalResultSuccess( heightWeightCombinationResult, coreValue, tailValue ) {
        $('#final_step .final_results').find('.length_result').text( heightWeightCombinationResult );
        $('#final_step .final_results').find('.core_result').text( coreValue  );
        $('#final_step .final_results').find('.tail_result').text( tailValue );
        
      	$( '.tab' ).addClass('ebody-inactive');
      	$( '#final_step' ).addClass('ebody-active').removeClass('ebody-inactive');
    }

    // set final result error
    function setFinalResultError( heightWeightCombinationResult, coreValue, tailValue ) {
    	var result_html = "<h1>THE BEST BOARD FOR YOU</h1>";
            result_html += '<div class="row riding-ability" id="ebody-best-board">';
            result_html += '<div class="col-md-4"><div class="riding-col"> ';
      	   	result_html += '<div class="final-info result-tip" data-type="length-tip" data-id="1" style=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.20006C14.301 2.20006 17.8 5.69906 17.8 10.0001C17.8 14.3011 14.301 17.8001 10 17.8001C5.699 17.8001 2.2 14.3011 2.2 10.0001C2.2 5.69906 5.699 2.20006 10 2.20006ZM10 1.00006C5.0294 1.00006 1 5.02946 1 10.0001C1 14.9707 5.0294 19.0001 10 19.0001C14.9706 19.0001 19 14.9707 19 10.0001C19 5.02946 14.9706 1.00006 10 1.00006Z" fill="#7D7D7D"></path><path d="M11.5851 13.3653C11.5851 13.5275 11.2025 13.9075 10.4375 14.5053C9.67234 15.1031 8.98094 15.4021 8.36274 15.4021C7.93714 15.4021 7.62814 15.2931 7.43554 15.0753C7.24294 14.8575 7.14674 14.6117 7.14674 14.3381C7.14674 14.1659 7.17194 14.0063 7.22274 13.8593C7.27334 13.7125 7.32914 13.5629 7.38994 13.4109L8.83394 10.4165C8.91494 10.2443 8.97334 10.1049 9.00874 9.99854C9.04414 9.89214 9.06194 9.79854 9.06194 9.71734C9.06194 9.63634 9.04674 9.57814 9.01634 9.54254C8.98594 9.50714 8.94534 9.48934 8.89474 9.48934C8.76294 9.48934 8.50714 9.68954 8.12714 10.0897C7.74714 10.4899 7.52154 10.6901 7.45074 10.6901C7.36974 10.6901 7.28854 10.6343 7.20754 10.5229C7.12634 10.4115 7.08594 10.3405 7.08594 10.3101C7.08594 10.2087 7.18214 10.0441 7.37474 9.81614C7.56714 9.58814 7.81054 9.34754 8.10434 9.09414C8.36774 8.86114 8.68434 8.64334 9.05434 8.44054C9.42414 8.23794 9.75094 8.13654 10.0347 8.13654C10.4907 8.13654 10.8327 8.26574 11.0607 8.52414C11.2887 8.78254 11.4027 9.09414 11.4027 9.45894C11.4027 9.61094 11.3875 9.77314 11.3571 9.94534C11.3267 10.1175 11.2609 10.2949 11.1595 10.4773L10.0043 13.0157C9.91314 13.2285 9.84714 13.4007 9.80674 13.5325C9.76614 13.6643 9.74594 13.7555 9.74594 13.8061C9.74594 13.8669 9.76114 13.9049 9.79154 13.9201C9.82194 13.9353 9.85234 13.9429 9.88274 13.9429C10.1055 13.9429 10.3665 13.7833 10.6655 13.4641C10.9645 13.1449 11.1543 12.9853 11.2355 12.9853C11.3063 12.9853 11.3823 13.0385 11.4635 13.1449C11.5445 13.2513 11.5851 13.3249 11.5851 13.3653Z" fill="#7D7D7D"></path><path d="M12.7586 5.52224C12.7586 5.89724 12.6244 6.22144 12.3558 6.49504C12.0872 6.76864 11.7604 6.90544 11.3754 6.90544C11.0004 6.90544 10.6762 6.76864 10.4026 6.49504C10.129 6.22144 9.99219 5.89724 9.99219 5.52224C9.99219 5.14724 10.129 4.82304 10.4026 4.54944C10.6762 4.27584 11.0004 4.13904 11.3754 4.13904C11.7604 4.13904 12.0872 4.27584 12.3558 4.54944C12.6244 4.82324 12.7586 5.14744 12.7586 5.52224Z" fill="#7D7D7D"></path></svg></div>';
            result_html += '<input type="radio" name="ebody-best-board"><h2>LENGTH</h2><p class="length_result"></p>';
            result_html += '</div></div>';
            result_html += '<div class="col-md-4"><div class="riding-col">';
           	result_html += '<div class="final-info result-tip" data-type="core-tip" data-id="1" style=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.20006C14.301 2.20006 17.8 5.69906 17.8 10.0001C17.8 14.3011 14.301 17.8001 10 17.8001C5.699 17.8001 2.2 14.3011 2.2 10.0001C2.2 5.69906 5.699 2.20006 10 2.20006ZM10 1.00006C5.0294 1.00006 1 5.02946 1 10.0001C1 14.9707 5.0294 19.0001 10 19.0001C14.9706 19.0001 19 14.9707 19 10.0001C19 5.02946 14.9706 1.00006 10 1.00006Z" fill="#7D7D7D"></path><path d="M11.5851 13.3653C11.5851 13.5275 11.2025 13.9075 10.4375 14.5053C9.67234 15.1031 8.98094 15.4021 8.36274 15.4021C7.93714 15.4021 7.62814 15.2931 7.43554 15.0753C7.24294 14.8575 7.14674 14.6117 7.14674 14.3381C7.14674 14.1659 7.17194 14.0063 7.22274 13.8593C7.27334 13.7125 7.32914 13.5629 7.38994 13.4109L8.83394 10.4165C8.91494 10.2443 8.97334 10.1049 9.00874 9.99854C9.04414 9.89214 9.06194 9.79854 9.06194 9.71734C9.06194 9.63634 9.04674 9.57814 9.01634 9.54254C8.98594 9.50714 8.94534 9.48934 8.89474 9.48934C8.76294 9.48934 8.50714 9.68954 8.12714 10.0897C7.74714 10.4899 7.52154 10.6901 7.45074 10.6901C7.36974 10.6901 7.28854 10.6343 7.20754 10.5229C7.12634 10.4115 7.08594 10.3405 7.08594 10.3101C7.08594 10.2087 7.18214 10.0441 7.37474 9.81614C7.56714 9.58814 7.81054 9.34754 8.10434 9.09414C8.36774 8.86114 8.68434 8.64334 9.05434 8.44054C9.42414 8.23794 9.75094 8.13654 10.0347 8.13654C10.4907 8.13654 10.8327 8.26574 11.0607 8.52414C11.2887 8.78254 11.4027 9.09414 11.4027 9.45894C11.4027 9.61094 11.3875 9.77314 11.3571 9.94534C11.3267 10.1175 11.2609 10.2949 11.1595 10.4773L10.0043 13.0157C9.91314 13.2285 9.84714 13.4007 9.80674 13.5325C9.76614 13.6643 9.74594 13.7555 9.74594 13.8061C9.74594 13.8669 9.76114 13.9049 9.79154 13.9201C9.82194 13.9353 9.85234 13.9429 9.88274 13.9429C10.1055 13.9429 10.3665 13.7833 10.6655 13.4641C10.9645 13.1449 11.1543 12.9853 11.2355 12.9853C11.3063 12.9853 11.3823 13.0385 11.4635 13.1449C11.5445 13.2513 11.5851 13.3249 11.5851 13.3653Z" fill="#7D7D7D"></path><path d="M12.7586 5.52224C12.7586 5.89724 12.6244 6.22144 12.3558 6.49504C12.0872 6.76864 11.7604 6.90544 11.3754 6.90544C11.0004 6.90544 10.6762 6.76864 10.4026 6.49504C10.129 6.22144 9.99219 5.89724 9.99219 5.52224C9.99219 5.14724 10.129 4.82304 10.4026 4.54944C10.6762 4.27584 11.0004 4.13904 11.3754 4.13904C11.7604 4.13904 12.0872 4.27584 12.3558 4.54944C12.6244 4.82324 12.7586 5.14744 12.7586 5.52224Z" fill="#7D7D7D"></path></svg></div>';
            result_html += '<input type="radio"  name="ebody-best-board"><h2>CORE</h2><p class="core_result"></p>';
            result_html += '</div></div>';
            result_html += '<div class="col-md-4"><div class="riding-col">';
            result_html += '<div class="final-info result-tip" data-type="tail-tip" data-id="1" style=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.20006C14.301 2.20006 17.8 5.69906 17.8 10.0001C17.8 14.3011 14.301 17.8001 10 17.8001C5.699 17.8001 2.2 14.3011 2.2 10.0001C2.2 5.69906 5.699 2.20006 10 2.20006ZM10 1.00006C5.0294 1.00006 1 5.02946 1 10.0001C1 14.9707 5.0294 19.0001 10 19.0001C14.9706 19.0001 19 14.9707 19 10.0001C19 5.02946 14.9706 1.00006 10 1.00006Z" fill="#7D7D7D"></path><path d="M11.5851 13.3653C11.5851 13.5275 11.2025 13.9075 10.4375 14.5053C9.67234 15.1031 8.98094 15.4021 8.36274 15.4021C7.93714 15.4021 7.62814 15.2931 7.43554 15.0753C7.24294 14.8575 7.14674 14.6117 7.14674 14.3381C7.14674 14.1659 7.17194 14.0063 7.22274 13.8593C7.27334 13.7125 7.32914 13.5629 7.38994 13.4109L8.83394 10.4165C8.91494 10.2443 8.97334 10.1049 9.00874 9.99854C9.04414 9.89214 9.06194 9.79854 9.06194 9.71734C9.06194 9.63634 9.04674 9.57814 9.01634 9.54254C8.98594 9.50714 8.94534 9.48934 8.89474 9.48934C8.76294 9.48934 8.50714 9.68954 8.12714 10.0897C7.74714 10.4899 7.52154 10.6901 7.45074 10.6901C7.36974 10.6901 7.28854 10.6343 7.20754 10.5229C7.12634 10.4115 7.08594 10.3405 7.08594 10.3101C7.08594 10.2087 7.18214 10.0441 7.37474 9.81614C7.56714 9.58814 7.81054 9.34754 8.10434 9.09414C8.36774 8.86114 8.68434 8.64334 9.05434 8.44054C9.42414 8.23794 9.75094 8.13654 10.0347 8.13654C10.4907 8.13654 10.8327 8.26574 11.0607 8.52414C11.2887 8.78254 11.4027 9.09414 11.4027 9.45894C11.4027 9.61094 11.3875 9.77314 11.3571 9.94534C11.3267 10.1175 11.2609 10.2949 11.1595 10.4773L10.0043 13.0157C9.91314 13.2285 9.84714 13.4007 9.80674 13.5325C9.76614 13.6643 9.74594 13.7555 9.74594 13.8061C9.74594 13.8669 9.76114 13.9049 9.79154 13.9201C9.82194 13.9353 9.85234 13.9429 9.88274 13.9429C10.1055 13.9429 10.3665 13.7833 10.6655 13.4641C10.9645 13.1449 11.1543 12.9853 11.2355 12.9853C11.3063 12.9853 11.3823 13.0385 11.4635 13.1449C11.5445 13.2513 11.5851 13.3249 11.5851 13.3653Z" fill="#7D7D7D"></path><path d="M12.7586 5.52224C12.7586 5.89724 12.6244 6.22144 12.3558 6.49504C12.0872 6.76864 11.7604 6.90544 11.3754 6.90544C11.0004 6.90544 10.6762 6.76864 10.4026 6.49504C10.129 6.22144 9.99219 5.89724 9.99219 5.52224C9.99219 5.14724 10.129 4.82304 10.4026 4.54944C10.6762 4.27584 11.0004 4.13904 11.3754 4.13904C11.7604 4.13904 12.0872 4.27584 12.3558 4.54944C12.6244 4.82324 12.7586 5.14744 12.7586 5.52224Z" fill="#7D7D7D"></path></svg></div>';
            result_html += '<input type="radio"  name="ebody-best-board"><h2>TAIL</h2> <p class="tail_result"></p>';
            result_html += '</div></div>';
            result_html += '</div>';
            result_html += "<h1 class='ebody-board'>NO BOARD FOUND FROM YOUR DETAILS</h1>";
      		result_html += "<div class='no-result-conatct'><p> Mmmmm...sorry we can't find any boards based on your answers.";
      		result_html += " try modifying your answers or";
        	result_html += '<a href="mailto:fahd@syde.agency"> contact us. </a></p></div>';
            result_html += '<p class="jump-to-questions"> Hint: Try a different';
            result_html += '<a class="jumpto-price-range" href="javascript:void(0)"> price range, </a>';
            result_html += '<a class="jumpto-riding-style" href="javascript:void(0)"> riding style </a>';
            result_html += 'or <a class="jumpto-wave-type" href="javascript:void(0)"> wave type </a>';
            result_html += 'in your answers</p>';
      
    	$('.board-btn .back-again').show();
        $('#final_step .final_results').html( result_html );
      
        if( heightWeightCombinationResult != 'no' || typeof heightWeightCombinationResult != 'undefined' ) {
          	$('#final_step .final_results').find('.length_result').text( heightWeightCombinationResult );
          	$('#final_step .final_results').find('.core_result').text( coreValue  );
          	$('#final_step .final_results').find('.tail_result').text( tailValue );
        } else {
           	$('#final_step .final_results').find('.length_result').text( 'Not defined' );
           	$('#final_step .final_results').find('.core_result').text( 'Not defined'  );
           	$('#final_step .final_results').find('.tail_result').text( 'Not defined' );
        }
       
        $( '.tab' ).addClass('ebody-inactive');
        $( '#final_step' ).addClass('ebody-active').removeClass('ebody-inactive');
    }



	// set final success html in the final_step .	
	function setFinalResultSuccessHtml(){
      	var result_html = "<h1>THE BEST BOARD FOR YOU</h1>";
      		result_html += '<div class="row riding-ability" id="ebody-best-board">';
            result_html += '<div class="col-md-4"><div class="riding-col">';
      	   	result_html += '<div class="final-info result-tip" data-type="length-tip" data-id="1" style=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.20006C14.301 2.20006 17.8 5.69906 17.8 10.0001C17.8 14.3011 14.301 17.8001 10 17.8001C5.699 17.8001 2.2 14.3011 2.2 10.0001C2.2 5.69906 5.699 2.20006 10 2.20006ZM10 1.00006C5.0294 1.00006 1 5.02946 1 10.0001C1 14.9707 5.0294 19.0001 10 19.0001C14.9706 19.0001 19 14.9707 19 10.0001C19 5.02946 14.9706 1.00006 10 1.00006Z" fill="#7D7D7D"></path><path d="M11.5851 13.3653C11.5851 13.5275 11.2025 13.9075 10.4375 14.5053C9.67234 15.1031 8.98094 15.4021 8.36274 15.4021C7.93714 15.4021 7.62814 15.2931 7.43554 15.0753C7.24294 14.8575 7.14674 14.6117 7.14674 14.3381C7.14674 14.1659 7.17194 14.0063 7.22274 13.8593C7.27334 13.7125 7.32914 13.5629 7.38994 13.4109L8.83394 10.4165C8.91494 10.2443 8.97334 10.1049 9.00874 9.99854C9.04414 9.89214 9.06194 9.79854 9.06194 9.71734C9.06194 9.63634 9.04674 9.57814 9.01634 9.54254C8.98594 9.50714 8.94534 9.48934 8.89474 9.48934C8.76294 9.48934 8.50714 9.68954 8.12714 10.0897C7.74714 10.4899 7.52154 10.6901 7.45074 10.6901C7.36974 10.6901 7.28854 10.6343 7.20754 10.5229C7.12634 10.4115 7.08594 10.3405 7.08594 10.3101C7.08594 10.2087 7.18214 10.0441 7.37474 9.81614C7.56714 9.58814 7.81054 9.34754 8.10434 9.09414C8.36774 8.86114 8.68434 8.64334 9.05434 8.44054C9.42414 8.23794 9.75094 8.13654 10.0347 8.13654C10.4907 8.13654 10.8327 8.26574 11.0607 8.52414C11.2887 8.78254 11.4027 9.09414 11.4027 9.45894C11.4027 9.61094 11.3875 9.77314 11.3571 9.94534C11.3267 10.1175 11.2609 10.2949 11.1595 10.4773L10.0043 13.0157C9.91314 13.2285 9.84714 13.4007 9.80674 13.5325C9.76614 13.6643 9.74594 13.7555 9.74594 13.8061C9.74594 13.8669 9.76114 13.9049 9.79154 13.9201C9.82194 13.9353 9.85234 13.9429 9.88274 13.9429C10.1055 13.9429 10.3665 13.7833 10.6655 13.4641C10.9645 13.1449 11.1543 12.9853 11.2355 12.9853C11.3063 12.9853 11.3823 13.0385 11.4635 13.1449C11.5445 13.2513 11.5851 13.3249 11.5851 13.3653Z" fill="#7D7D7D"></path><path d="M12.7586 5.52224C12.7586 5.89724 12.6244 6.22144 12.3558 6.49504C12.0872 6.76864 11.7604 6.90544 11.3754 6.90544C11.0004 6.90544 10.6762 6.76864 10.4026 6.49504C10.129 6.22144 9.99219 5.89724 9.99219 5.52224C9.99219 5.14724 10.129 4.82304 10.4026 4.54944C10.6762 4.27584 11.0004 4.13904 11.3754 4.13904C11.7604 4.13904 12.0872 4.27584 12.3558 4.54944C12.6244 4.82324 12.7586 5.14744 12.7586 5.52224Z" fill="#7D7D7D"></path></svg></div>';
            result_html += '<input type="radio" name="ebody-best-board"><h2>LENGTH</h2><p class="length_result"></p>';
            result_html += '</div></div>';
            result_html += '<div class="col-md-4"><div class="riding-col">';
           	result_html += '<div class="final-info result-tip" data-type="core-tip" data-id="1" style=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.20006C14.301 2.20006 17.8 5.69906 17.8 10.0001C17.8 14.3011 14.301 17.8001 10 17.8001C5.699 17.8001 2.2 14.3011 2.2 10.0001C2.2 5.69906 5.699 2.20006 10 2.20006ZM10 1.00006C5.0294 1.00006 1 5.02946 1 10.0001C1 14.9707 5.0294 19.0001 10 19.0001C14.9706 19.0001 19 14.9707 19 10.0001C19 5.02946 14.9706 1.00006 10 1.00006Z" fill="#7D7D7D"></path><path d="M11.5851 13.3653C11.5851 13.5275 11.2025 13.9075 10.4375 14.5053C9.67234 15.1031 8.98094 15.4021 8.36274 15.4021C7.93714 15.4021 7.62814 15.2931 7.43554 15.0753C7.24294 14.8575 7.14674 14.6117 7.14674 14.3381C7.14674 14.1659 7.17194 14.0063 7.22274 13.8593C7.27334 13.7125 7.32914 13.5629 7.38994 13.4109L8.83394 10.4165C8.91494 10.2443 8.97334 10.1049 9.00874 9.99854C9.04414 9.89214 9.06194 9.79854 9.06194 9.71734C9.06194 9.63634 9.04674 9.57814 9.01634 9.54254C8.98594 9.50714 8.94534 9.48934 8.89474 9.48934C8.76294 9.48934 8.50714 9.68954 8.12714 10.0897C7.74714 10.4899 7.52154 10.6901 7.45074 10.6901C7.36974 10.6901 7.28854 10.6343 7.20754 10.5229C7.12634 10.4115 7.08594 10.3405 7.08594 10.3101C7.08594 10.2087 7.18214 10.0441 7.37474 9.81614C7.56714 9.58814 7.81054 9.34754 8.10434 9.09414C8.36774 8.86114 8.68434 8.64334 9.05434 8.44054C9.42414 8.23794 9.75094 8.13654 10.0347 8.13654C10.4907 8.13654 10.8327 8.26574 11.0607 8.52414C11.2887 8.78254 11.4027 9.09414 11.4027 9.45894C11.4027 9.61094 11.3875 9.77314 11.3571 9.94534C11.3267 10.1175 11.2609 10.2949 11.1595 10.4773L10.0043 13.0157C9.91314 13.2285 9.84714 13.4007 9.80674 13.5325C9.76614 13.6643 9.74594 13.7555 9.74594 13.8061C9.74594 13.8669 9.76114 13.9049 9.79154 13.9201C9.82194 13.9353 9.85234 13.9429 9.88274 13.9429C10.1055 13.9429 10.3665 13.7833 10.6655 13.4641C10.9645 13.1449 11.1543 12.9853 11.2355 12.9853C11.3063 12.9853 11.3823 13.0385 11.4635 13.1449C11.5445 13.2513 11.5851 13.3249 11.5851 13.3653Z" fill="#7D7D7D"></path><path d="M12.7586 5.52224C12.7586 5.89724 12.6244 6.22144 12.3558 6.49504C12.0872 6.76864 11.7604 6.90544 11.3754 6.90544C11.0004 6.90544 10.6762 6.76864 10.4026 6.49504C10.129 6.22144 9.99219 5.89724 9.99219 5.52224C9.99219 5.14724 10.129 4.82304 10.4026 4.54944C10.6762 4.27584 11.0004 4.13904 11.3754 4.13904C11.7604 4.13904 12.0872 4.27584 12.3558 4.54944C12.6244 4.82324 12.7586 5.14744 12.7586 5.52224Z" fill="#7D7D7D"></path></svg></div>';
            result_html += '<input type="radio"  name="ebody-best-board"><h2>CORE</h2><p class="core_result"></p>';
            result_html += '</div></div>';
            result_html += '<div class="col-md-4"><div class="riding-col">';
            result_html += '<div class="final-info result-tip" data-type="tail-tip" data-id="1" style=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2.20006C14.301 2.20006 17.8 5.69906 17.8 10.0001C17.8 14.3011 14.301 17.8001 10 17.8001C5.699 17.8001 2.2 14.3011 2.2 10.0001C2.2 5.69906 5.699 2.20006 10 2.20006ZM10 1.00006C5.0294 1.00006 1 5.02946 1 10.0001C1 14.9707 5.0294 19.0001 10 19.0001C14.9706 19.0001 19 14.9707 19 10.0001C19 5.02946 14.9706 1.00006 10 1.00006Z" fill="#7D7D7D"></path><path d="M11.5851 13.3653C11.5851 13.5275 11.2025 13.9075 10.4375 14.5053C9.67234 15.1031 8.98094 15.4021 8.36274 15.4021C7.93714 15.4021 7.62814 15.2931 7.43554 15.0753C7.24294 14.8575 7.14674 14.6117 7.14674 14.3381C7.14674 14.1659 7.17194 14.0063 7.22274 13.8593C7.27334 13.7125 7.32914 13.5629 7.38994 13.4109L8.83394 10.4165C8.91494 10.2443 8.97334 10.1049 9.00874 9.99854C9.04414 9.89214 9.06194 9.79854 9.06194 9.71734C9.06194 9.63634 9.04674 9.57814 9.01634 9.54254C8.98594 9.50714 8.94534 9.48934 8.89474 9.48934C8.76294 9.48934 8.50714 9.68954 8.12714 10.0897C7.74714 10.4899 7.52154 10.6901 7.45074 10.6901C7.36974 10.6901 7.28854 10.6343 7.20754 10.5229C7.12634 10.4115 7.08594 10.3405 7.08594 10.3101C7.08594 10.2087 7.18214 10.0441 7.37474 9.81614C7.56714 9.58814 7.81054 9.34754 8.10434 9.09414C8.36774 8.86114 8.68434 8.64334 9.05434 8.44054C9.42414 8.23794 9.75094 8.13654 10.0347 8.13654C10.4907 8.13654 10.8327 8.26574 11.0607 8.52414C11.2887 8.78254 11.4027 9.09414 11.4027 9.45894C11.4027 9.61094 11.3875 9.77314 11.3571 9.94534C11.3267 10.1175 11.2609 10.2949 11.1595 10.4773L10.0043 13.0157C9.91314 13.2285 9.84714 13.4007 9.80674 13.5325C9.76614 13.6643 9.74594 13.7555 9.74594 13.8061C9.74594 13.8669 9.76114 13.9049 9.79154 13.9201C9.82194 13.9353 9.85234 13.9429 9.88274 13.9429C10.1055 13.9429 10.3665 13.7833 10.6655 13.4641C10.9645 13.1449 11.1543 12.9853 11.2355 12.9853C11.3063 12.9853 11.3823 13.0385 11.4635 13.1449C11.5445 13.2513 11.5851 13.3249 11.5851 13.3653Z" fill="#7D7D7D"></path><path d="M12.7586 5.52224C12.7586 5.89724 12.6244 6.22144 12.3558 6.49504C12.0872 6.76864 11.7604 6.90544 11.3754 6.90544C11.0004 6.90544 10.6762 6.76864 10.4026 6.49504C10.129 6.22144 9.99219 5.89724 9.99219 5.52224C9.99219 5.14724 10.129 4.82304 10.4026 4.54944C10.6762 4.27584 11.0004 4.13904 11.3754 4.13904C11.7604 4.13904 12.0872 4.27584 12.3558 4.54944C12.6244 4.82324 12.7586 5.14744 12.7586 5.52224Z" fill="#7D7D7D"></path></svg></div>';
            result_html += '<input type="radio"  name="ebody-best-board"><h2>TAIL</h2> <p class="tail_result"></p>';
            result_html += '</div></div>';
            result_html += '</div>';
      		result_html += '<div class="row riding-ability-question">';
      		result_html += '<div class="col-md-4"> <div class="result-question"> <a target="_blank" href="https://www.ebodyboarding.com/pages/8-steps-to-choosing-the-right-bodyboard-for-you/"> Go longer or shorter? </a> </div> </div>';
      		result_html += '<div class="col-md-4"> <div class="result-question"> <a target="_blank" href="https://www.ebodyboarding.com/pages/8-steps-to-choosing-the-right-bodyboard-for-you/"> Which core to choose? </a> </div> </div>';
      		result_html += '<div class="col-md-4"> <div class="result-question"> <a target="_blank" href="https://www.ebodyboarding.com/pages/8-steps-to-choosing-the-right-bodyboard-for-you/"> Which tail is best? </a> </div> </div>';
      		result_html += '</div>';
      		result_html += '<h1 class="ebody-board">THE BEST BOARDS FOR YOU</h1><div class="row riding-ability" id="ebody-best-board-for-you"></div>';
      
      	$('.quiz-again').show();
      	$('.back-again').hide();
        $('#final_step .final_results').html( result_html );
    }


	// final result tips click
	$(document).on('click' , '.result-tip', function(){
      
      	$('.ebodyboarding-tips').hide();
      	//var type = $(this).find('.result-tip').data('type');
      
      	var type = $(this).data('type');
      
      	if( type == 'length-tip' ) {
         	$('#tip9').show()
        } else if ( type == 'core-tip' ) {
         	$('#tip10').show()
      	} else if ( type == 'tail-tip' ) {
         	$('#tip11').show()
        }
    });


	// check if email is valid or not 	
    function IsEmail(email) {
      var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if(!regex.test(email)) {
        return false;
      }else{
        return true;
      }
    }


	// functon that remove an arrat element  	
 	Array.prototype.remove = function() {
        var what, a = arguments, L = a.length, ax;
        while (L && this.length) {
            what = a[--L];
            while ((ax = this.indexOf(what)) !== -1) {
                this.splice(ax, 1);
            }
        }
        return this;
    };


// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};